import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    readAllInventory,
    createInventory,
    updateInventory,
    deleteInventory,
    readAllLocations,
    readAllProducts,
} from '../../helpers';
import {
    inventoryApiResponseSuccess,
    inventoryApiResponseError,
    inventoryGetAllInventory,
} from './actions';
import { InventoryActionTypes } from './constants';
import {
    inventoryResponseToInventoryObject,
    inventoryObjectToInventoryRequest,
} from '../../helpers/mappers/inventory';

export function* readAllInventorySaga({ payload: { query } }) {
    try {
        const response = yield call(readAllInventory, query);
        const locationsResponse = yield call(readAllLocations, null);
        const productsResponse = yield call(readAllProducts, null);
        const inventoryEntries = response.data.map((inventoryResponse) =>
            inventoryResponseToInventoryObject(inventoryResponse, productsResponse.data, locationsResponse.data)
        );
        yield put(inventoryApiResponseSuccess(InventoryActionTypes.READ_ALL_INVENTORY_REQUEST, inventoryEntries));
    } catch (error) {
        yield put(inventoryApiResponseError(InventoryActionTypes.READ_ALL_INVENTORY_REQUEST, error));
    }
}

export function* createInventorySaga({ payload: { inventory, callback } }) {
    try {
        const inventoryRequest = inventoryObjectToInventoryRequest(inventory);
        const response = yield call(createInventory, inventoryRequest);
        const inventoryResponse = inventoryResponseToInventoryObject(response, null, null);
        yield put(inventoryApiResponseSuccess(InventoryActionTypes.CREATE_INVENTORY_REQUEST, inventoryResponse));
        yield put(inventoryGetAllInventory());
    } catch (error) {
        yield put(inventoryApiResponseError(InventoryActionTypes.CREATE_INVENTORY_REQUEST, error));
    } finally {
        callback?.();
    }
}

function* updateInventorySaga({ payload: { inventoryId, inventory } }) {
    try {
        const inventoryRequest = inventoryObjectToInventoryRequest(inventory);
        const response = yield call(updateInventory, inventoryId, inventoryRequest);
        const inventoryResponse = inventoryResponseToInventoryObject(response, null, null);
        yield put(inventoryApiResponseSuccess(InventoryActionTypes.UPDATE_INVENTORY_REQUEST, inventoryResponse));
        yield put(inventoryGetAllInventory());
    } catch (error) {
        yield put(inventoryApiResponseError(InventoryActionTypes.UPDATE_INVENTORY_REQUEST, error));
    }
}

function* deleteInventorySaga({ payload: { inventoryId } }) {
    try {
        // response should be HTTP success with empty body
        const response = yield call(deleteInventory, inventoryId);
        yield put(inventoryApiResponseSuccess(InventoryActionTypes.DELETE_INVENTORY_REQUEST, response));
        yield put(inventoryGetAllInventory());
    } catch (error) {
        yield put(inventoryApiResponseError(InventoryActionTypes.DELETE_INVENTORY_REQUEST, error));
    }
}

export function* watchReadAllInventorySaga() {
    yield takeLatest(InventoryActionTypes.READ_ALL_INVENTORY_REQUEST, readAllInventorySaga);
}

export function* watchCreateInventorySaga() {
    yield takeLatest(InventoryActionTypes.CREATE_INVENTORY_REQUEST, createInventorySaga);
}

export function* watchUpdateInventorySaga() {
    yield takeLatest(InventoryActionTypes.UPDATE_INVENTORY_REQUEST, updateInventorySaga);
}

export function* watchDeleteInventorySaga() {
    yield takeLatest(InventoryActionTypes.DELETE_INVENTORY_REQUEST, deleteInventorySaga);
}

function* inventorySaga() {
    yield all([
        fork(watchReadAllInventorySaga),
        fork(watchCreateInventorySaga),
        fork(watchUpdateInventorySaga),
        fork(watchDeleteInventorySaga),
    ]);
}

export default inventorySaga;
